// icons
import { MdAccountBalanceWallet, MdPayments, MdReceipt, MdAccountBalance, MdAddShoppingCart } from "react-icons/md";

const cajaChica = {
  id: 'caja-chica-group',
  type: 'group',
  roles: [1, 200],
  breadcrumbs: false,
  children: [
    {
      id: 'caja-chica',
      title: "Caja Chica",
      type: 'collapse',
      icon: MdAccountBalanceWallet,
      children: [
        {
          id: 'saldo-movimientos',
          title: "Saldo y Movimientos",
          type: 'item',
          breadcrumbs: false,
          icon: MdAccountBalance,
          url: '/caja-chica/saldo-movimientos'
        },
        {
          id: 'agregar-gasto',
          title: "Agregar Gasto",
          type: 'item',
          breadcrumbs: false,
          icon: MdAddShoppingCart,
          url: '/caja-chica/agregar-gasto'
        },
        {
          id: 'bitacora-cobros',
          title: "Bitácora de Cobros",
          type: 'item',
          breadcrumbs: false,
          icon: MdReceipt,
          url: '/caja-chica/bitacora-cobros',
          roles: [200]
        }
      ]
    }
  ]
};

export default cajaChica;
